import { loadable } from '@shared/core/loadableFromNamedExport';

// Its own chunk, loaded only when a couple clicks Publish on their unpublished site's banner: it
// carries the publish hook and its translations, which no guest needs.
export const LazyGoLiveChecksIntroHost = loadable(() => import(/* webpackChunkName: "guest/go-live-checks-intro-host" */ './GoLiveChecksIntroHost'), 'GoLiveChecksIntroHost');
